import React, { useRef } from "react";

import {
  MinusOutlined,
  ReloadOutlined,
  ExportOutlined,
  ImportOutlined,
  CloseOutlined,
} from "@ant-design/icons";

import Logo from "../Images/logo.png";
import apiService from "../Services/apiServices";

function Header(props) {
  const isProcessing = useRef(false);

  const {
    showMinimizedChat,
    setShowMinimizedChat,
    showMaximumChat,
    setIsShowMaximumChat,
    handleClose,
    clearMessages,
    setShowMsgs,
    startLogin,
    setFinalTimerFlag,
    setCheckThumsDownFeedback,
    hasActiveTabs,
  } = props;
  return (
    <div style={{ height: showMaximumChat && (hasActiveTabs ? "2vh" : "5vh") }} className="bot-header">
      <div className="bot-logo">
        <img src={Logo} alt="logo"></img>
      </div>
      <div className="bot-head-action-items">
        {!showMinimizedChat && (
          <ReloadOutlined
            className="bot-head-action-icon"
            onClick={() => {
              if (isProcessing.current) return; 

              isProcessing.current = true;

              clearMessages();
              setShowMsgs(false);
              // apiService.loginForRefresh("6");
              startLogin();
              setCheckThumsDownFeedback([]);
              props?.setShowR1FeedbackPop((prevState) => ({ ...prevState, isActive: false }));
              props?.resetAllTabs?.();
              props?.resetQuickActions?.();
              sessionStorage.removeItem('expandedSections');
              setTimeout(() => {
                isProcessing.current = false;
              }, 2000);
            }}
          />
        )}

        {!showMaximumChat && !showMinimizedChat && (
          <MinusOutlined
            className="bot-head-action-icon"
            onClick={() => setShowMinimizedChat(true)}
          />
        )}
        {!showMaximumChat && (
          <ExportOutlined
            className="bot-head-action-icon"
            onClick={() => {
              showMinimizedChat
                ? setShowMinimizedChat(false)
                : setIsShowMaximumChat(!showMaximumChat);
            }}
          />
        )}
        {showMaximumChat && (
          <ImportOutlined
            onClick={() => {
              props?.setActiveTab("main");
              setIsShowMaximumChat(!showMaximumChat)}
            }
          />
        )}

        <CloseOutlined
          className="bot-head-action-icon"
          onClick={() => {
            props?.resetAllTabs?.();
            clearMessages();
              setShowMsgs(false);
              // apiService.loginForRefresh("6");
              // startLogin();
              setCheckThumsDownFeedback([]);
            handleClose()}}
        />
      </div>
    </div>
  );
}

export default Header;
